import { render, staticRenderFns } from "./SpecificationSectionCreate.vue?vue&type=template&id=537fbe8e"
import script from "./SpecificationSectionCreate.vue?vue&type=script&lang=js"
export * from "./SpecificationSectionCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports